import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSearch, 
    faFilter, 
    faDownload, 
    faFilePdf, 
    faCheckCircle, 
    faClock, 
    faUserCheck, 
    faEye, 
    faComments,
    faExternalLinkAlt,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';

const Reportes5 = () => {
    // Datos de API
    const [reporteDatos, setReporteDatos] = useState([]);
    const [loading, setLoading] = useState(false);

    const getPrimerDiaMesActual = () => {
        const d = new Date();
        d.setDate(1);
        return d.toISOString().split('T')[0];
    };
    const getUltimoDiaMesActual = () => {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        d.setDate(0);
        return d.toISOString().split('T')[0];
    };

    const [fechaDesde, setFechaDesde] = useState(getPrimerDiaMesActual());
    const [fechaHasta, setFechaHasta] = useState(getUltimoDiaMesActual());
    const [pacienteFiltro, setPacienteFiltro] = useState('');
    const [procesadoFiltro, setProcesadoFiltro] = useState('No'); // Por defecto 'No' para auditar pacientes nuevos

    useEffect(() => {
        cargarReporte();
    }, []);

    const cargarReporte = async () => {
        setLoading(true);
        try {
            const response = await authAxios.post('reportes/reportes_5', {
                fecha_inicial: fechaDesde,
                fecha_final: fechaHasta,
                paciente: pacienteFiltro,
                procesado: procesadoFiltro
            });
            if (response.data?.Status) {
                setReporteDatos(response.data.datos || []);
            } else {
                setReporteDatos([]);
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudieron cargar los datos de auditoría de remisiones', 'error');
            console.error(error);
        }
        setLoading(false);
    };

    // Modal para auditar y procesar el paciente / remisión
    const handleProcesar = (item) => {
        Swal.fire({
            title: 'Auditar Remisión y Paciente',
            html: `
                <div class="text-start" style="font-size: 0.9rem;">
                    <p class="mb-1"><strong>Paciente:</strong> ${item.paciente_nombre_completo || 'N/A'}</p>
                    <p class="mb-1"><strong>Cédula:</strong> ${item.cedula || 'N/A'}</p>
                    <p class="mb-1"><strong>Remisión / Autorización:</strong> ${item.numero_remision || item.autorizacion || 'N/A'}</p>
                    <p class="mb-3"><strong>Fecha Proceso:</strong> ${item.fecha_proceso || 'N/A'}</p>
                    <label class="form-label fw-bold">Observaciones de Auditoría (Vía libre para orden interna):</label>
                    <textarea id="swal-obs" class="form-control form-control-sm" rows="3" placeholder="Ej: Se valida remisión correcta, tiene vía libre para generar orden interna.">${item.observaciones || ''}</textarea>
                    <div class="mt-3 form-check">
                        <input class="form-check-input" type="checkbox" id="swal-procesar" checked>
                        <label class="form-check-label fw-bold text-success" for="swal-procesar">
                            Marcar como Procesado (Sí) y enviar correo de confirmación
                        </label>
                    </div>
                </div>
            `,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            confirmButtonText: '<i class="fa fa-check"></i> Guardar y Procesar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const obs = document.getElementById('swal-obs').value;
                const esProcesado = document.getElementById('swal-procesar').checked;
                return { observaciones: obs, procesado: esProcesado ? 'Si' : 'No' };
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const { observaciones, procesado } = result.value;
                try {
                    Swal.fire({
                        title: 'Procesando...',
                        text: 'Actualizando registro y enviando confirmación',
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading()
                    });

                    const res = await authAxios.post('reportes/reportes_5/procesar', {
                        id: item.auditoria_id,
                        procesado: procesado,
                        observaciones: observaciones
                    });

                    if (res.data?.Status) {
                        Swal.fire(
                            '¡Procesado!',
                            res.data.message || 'Auditoría actualizada con éxito.',
                            'success'
                        );
                        cargarReporte();
                    } else {
                        Swal.fire('Error', res.data?.message || 'No se pudo procesar', 'error');
                    }
                } catch (err) {
                    console.error(err);
                    Swal.fire('Error', 'Ocurrió un error al procesar la auditoría', 'error');
                }
            }
        });
    };

    const exportarExcel = () => {
        if (reporteDatos.length === 0) {
            Swal.fire('Atención', 'No hay datos para exportar', 'warning');
            return;
        }

        let excelData = [];
        reporteDatos.forEach(item => {
            excelData.push({
                "ID Auditoría": item.auditoria_id || '-',
                "Fecha Proceso": item.fecha_proceso || '-',
                "Cédula": item.cedula || '-',
                "Paciente": item.paciente_nombre_completo || '-',
                "Teléfono": item.telefono || item.celular || '-',
                "Dirección": item.direccion || '-',
                "Barrio": item.barrio || '-',
                "Diagnóstico": `${item.diagnostico_principal || ''} - ${item.diagnostico_nombre || ''}`,
                "No. Remisión": item.numero_remision || item.autorizacion || '-',
                "Procesado": item.procesado || 'No',
                "Confirmado": item.confirmado || 'No',
                "Fecha Confirmación": item.fecha_confirmacion || '-',
                "Observaciones": item.observaciones || '-',
                "Tiene Archivo PDF": item.archivo_pdf ? 'Sí' : 'No'
            });
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Auditoría Remisiones");
        XLSX.writeFile(workbook, `Reporte_Auditoria_Remisiones_SURA_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    const getPdfUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        return `https://backto.idbkoala.com/storage/${path}`;
    };

    return (
        <div className="content-wrapper">
            <div className="content">
                <div className="container-fluid pt-4">
                    {/* Tarjeta de Filtros */}
                    <div className="card shadow-sm mb-4" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white border-bottom">
                            <h4 className="card-title text-primary m-0" style={{ fontWeight: '600' }}>
                                <FontAwesomeIcon icon={faFilter} className="me-2" />
                                Filtros - Reporte 5: Auditoría Remisiones SURA (Pacientes Nuevos)
                            </h4>
                        </div>
                        <div className="card-body bg-light">
                            <div className="row g-3 align-items-end">
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Desde</label>
                                    <input 
                                        type="date" 
                                        className="form-control form-control-sm" 
                                        value={fechaDesde} 
                                        onChange={e => setFechaDesde(e.target.value)} 
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Hasta</label>
                                    <input 
                                        type="date" 
                                        className="form-control form-control-sm" 
                                        value={fechaHasta} 
                                        onChange={e => setFechaHasta(e.target.value)} 
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Paciente o Remisión</label>
                                    <input 
                                        type="text" 
                                        className="form-control form-control-sm" 
                                        placeholder="Cédula, nombre o no. remisión" 
                                        value={pacienteFiltro} 
                                        onChange={e => setPacienteFiltro(e.target.value)} 
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Estado Procesado</label>
                                    <select 
                                        className="form-select form-select-sm" 
                                        value={procesadoFiltro} 
                                        onChange={e => setProcesadoFiltro(e.target.value)}
                                    >
                                        <option value="No">Solo No Procesados (Pendientes)</option>
                                        <option value="Si">Solo Procesados</option>
                                        <option value="">Todos</option>
                                    </select>
                                </div>

                                <div className="col-md-3 text-end">
                                    <button 
                                        className="btn btn-primary btn-sm w-100" 
                                        onClick={cargarReporte} 
                                        disabled={loading}
                                    >
                                        <FontAwesomeIcon icon={faSearch} className="me-1" /> Generar Reporte
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabla de Resultados */}
                    <div className="card shadow-sm" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="card-title m-0 fw-bold">
                                Resultados de la Auditoría ({reporteDatos.length})
                            </h5>
                            <div>
                                <button 
                                    className="btn btn-success btn-sm" 
                                    onClick={exportarExcel} 
                                    disabled={loading || reporteDatos.length === 0}
                                >
                                    <FontAwesomeIcon icon={faDownload} className="me-1" /> Exportar Excel
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped align-middle m-0" style={{ fontSize: '0.85rem' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th># Auditoría</th>
                                            <th className="text-center">Fecha Proceso</th>
                                            <th>Cédula</th>
                                            <th>Paciente</th>
                                            <th>Remisión / Aut.</th>
                                            <th>Diagnóstico</th>
                                            <th className="text-center">Archivo PDF</th>
                                            <th className="text-center">Procesado</th>
                                            <th className="text-center">Confirmación</th>
                                            <th>Observaciones</th>
                                            <th className="text-center">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reporteDatos.length === 0 ? (
                                            <tr>
                                                <td colSpan="11" className="text-center py-5">
                                                    {loading ? (
                                                        <div>Cargando datos de auditoría...</div>
                                                    ) : (
                                                        <div className="text-muted">
                                                            <FontAwesomeIcon icon={faSearch} size="2x" className="mb-2 d-block mx-auto" /> 
                                                            No se encontraron remisiones pendientes con los filtros aplicados.
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ) : (
                                            reporteDatos.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td className="fw-bold">#{item.auditoria_id || '-'}</td>
                                                    <td className="text-center">
                                                        <span className="badge bg-light text-dark border">
                                                            <FontAwesomeIcon icon={faClock} className="me-1 text-primary" />
                                                            {item.fecha_proceso || '-'}
                                                        </span>
                                                    </td>
                                                    <td className="fw-bold text-dark">{item.cedula || '-'}</td>
                                                    <td>
                                                        <div className="fw-bold">{item.paciente_nombre_completo || '-'}</div>
                                                        <small className="text-muted">{item.celular || item.telefono || 'Sin tel.'}</small>
                                                    </td>
                                                    <td>
                                                        <span className="badge bg-info text-dark">
                                                            {item.numero_remision || item.autorizacion || '-'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span title={item.diagnostico_nombre || ''}>
                                                            {item.diagnostico_principal || '-'}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        {item.archivo_pdf ? (
                                                            <a 
                                                                href={getPdfUrl(item.archivo_pdf)} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer" 
                                                                className="btn btn-outline-danger btn-sm py-0 px-2"
                                                                title="Ver/Descargar PDF Remisión"
                                                            >
                                                                <FontAwesomeIcon icon={faFilePdf} className="me-1" />
                                                                PDF
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted small">Sin archivo</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.procesado === 'Si' ? (
                                                            <span className="badge bg-success">
                                                                <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                                                                Procesado (Sí)
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-warning text-dark">
                                                                <FontAwesomeIcon icon={faExclamationTriangle} className="me-1" />
                                                                Pendiente (No)
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.confirmado === 'Si' ? (
                                                            <span className="badge bg-success-light text-success border border-success">
                                                                Enviado
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-secondary-light text-muted border">
                                                                Sin enviar
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td style={{ maxWidth: '220px' }}>
                                                        <div className="text-truncate" title={item.observaciones || 'Sin observaciones'}>
                                                            {item.observaciones || <span className="text-muted fst-italic">Sin observaciones</span>}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <button 
                                                            className={`btn btn-sm ${item.procesado === 'Si' ? 'btn-outline-secondary' : 'btn-success'}`}
                                                            onClick={() => handleProcesar(item)}
                                                            title={item.procesado === 'Si' ? 'Editar auditoría / observaciones' : 'Auditar y dar vía libre'}
                                                        >
                                                            <FontAwesomeIcon icon={faUserCheck} className="me-1" />
                                                            {item.procesado === 'Si' ? 'Editar' : 'Auditar'}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reportes5;
